export default __webpack_public_path__ + "static/media/M1POP.78142fd0.jpg";